import { gql } from '@apollo/client';

export const fetchBillingProfileNameById = gql`
  query fetchBillingProfileNameById($id: ID!, $txaId: ID) {
    invoiceGroup(id: $id, txaId: $txaId) {
      name
      invoiceGroupNumber
    }
  }
`;
